import React from "react";
import {
  FooterContainer,
  FooterH1,
  FooterLink,
  FooterLinksContainer,
  FooterWrapper,
} from "./FooterElements";
import { FaInstagram, FaFacebook, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper className="container py-5">
        <div className="row">
          <div className="col-12 mt-5">
            <FooterH1>- AlphaC  -</FooterH1>
          </div>
        </div>
        <FooterLinksContainer>
          <FooterLink href="#">
            <FaInstagram />
            Instagram
          </FooterLink>
          <FooterLink href="#">
            <FaFacebook />
            Facebook
          </FooterLink>
          <FooterLink href="#">
            <FaLinkedin />
            LinkedIn
          </FooterLink>
        </FooterLinksContainer>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;
